module.exports = __webpack_public_path__ + "img/bg.7c4b864d.jpeg";